import { GfhAccountStatus } from "@core/enums/account-status";
import {
  ProductVersion,
  ProductVersionModel,
} from "@core/models/product-version.model";
import { PrivateUser } from "@core/models/user-private.model";
import { Advisor } from "@models/advisor.model";
import { Intermediary } from "@models/intermediary.model";
import { Product } from "@models/product.model";

import { UserExtended } from "./user-extended.model";

export interface GfhAccountModel {
  advisor: Advisor;
  accountNumber: string;
  advisorId: string;
  afasCrmId: string;
  afasEmployeeId: string;
  allowOwnDeposit: boolean;
  allowPeriodicDeposit: boolean;
  balance: number;
  balanceCurrency: string;
  clientId: string;
  closureId: string;
  contraAccountId: string;
  currentAmountFictionalUnits: any; // TODO: Adjust the type accordingly
  definitiveClosingDate: string;
  deposit: number;
  depositCollectionPeriod: number | null;
  disbursementPeriod: number;
  endDate: string;
  endDateDeposit: string;
  endDateDisbursement: string;
  errorAccount: boolean;
  exchangeInformation: number;
  fictionalUnitsPerPeriod: any; // TODO: Adjust the type accordingly
  fiscalRegimeId: string;
  hasDeviatedCosts: boolean;
  id: string;
  incidentalPaymentInTax: boolean;
  intermediaryId: string;
  intermediary: Intermediary;
  intendedFor: number;
  lastCollectionBatchId: string;
  legacy: boolean;
  minorBirthDate: string;
  minorFirstName: string;
  minorInitials: string;
  minorLastName: string;
  minorLastNamePrefix: string;
  newRiskProfileId: string;
  originalAmountFictionalUnits: any; // TODO: Adjust the type accordingly
  ownDeposit: any; // TODO: Adjust the type accordingly
  owner: UserExtended;
  pauseDepositCollection: boolean;
  paused: boolean;
  product: Product;
  periodicPaymentInTax: boolean;
  productKind: number;
  productVersion: ProductVersionModel;
  productVersionChanged: boolean;
  productVersionId: string;
  registrantCity: string;
  registrantName: string;
  riskProfile: any; // TODO: Adjust the type accordingly
  startDate: string;
  startDateDeposit: string;
  startDateDisbursement: string;
  status: GfhAccountStatus;
  totalValue: number;
  utcInsertDate: string;
  utcUpdateDate: string;
  version: string;
}

export class GfhAccount implements GfhAccountModel {
  advisor = new Advisor();
  accountNumber = "";
  advisorId = "";
  afasCrmId = "";
  afasEmployeeId = "";
  allowOwnDeposit = false;
  allowPeriodicDeposit = false;
  balance = -1;
  balanceCurrency = "";
  clientId = "";
  closureId = "";
  contraAccountId = "";
  currentAmountFictionalUnits: any = null; // TODO: Adjust the type accordingly
  definitiveClosingDate = "";
  deposit = -1;
  depositCollectionPeriod: number | null = null;
  disbursementPeriod = -1;
  endDate = "";
  endDateDeposit = "";
  endDateDisbursement = "";
  errorAccount = false;
  exchangeInformation = -1;
  fictionalUnitsPerPeriod: any = null; // TODO: Adjust the type accordingly
  fiscalRegimeId = "";
  hasDeviatedCosts = false;
  id = "";
  incidentalPaymentInTax = false;
  intermediaryId = "";
  intermediary = new Intermediary();
  intendedFor = -1;
  lastCollectionBatchId = "";
  legacy = false;
  minorBirthDate = "";
  minorFirstName = "";
  minorInitials = "";
  minorLastName = "";
  minorLastNamePrefix = "";
  newRiskProfileId = "";
  originalAmountFictionalUnits: any = null; // TODO: Adjust the type accordingly
  ownDeposit: any = null; // TODO: Adjust the type accordingly
  owner = new PrivateUser();
  pauseDepositCollection = false;
  paused = false;
  periodicPaymentInTax = false;
  product: Product = new Product();
  productKind = 0;
  productVersionChanged = false;
  productVersion = new ProductVersion();
  productVersionId = "";
  registrantCity = "";
  registrantName = "";
  riskProfile: any = null; // TODO: Adjust the type accordingly
  startDate = "";
  startDateDeposit = "";
  startDateDisbursement = "";
  status = GfhAccountStatus.WaitingForIdentification;
  totalValue = -1;
  utcInsertDate = "";
  utcUpdateDate = "";
  version = "";

  constructor(dto?: GfhAccountModel) {
    if (!dto) {
      return;
    }
    Object.assign(this, dto);
  }
}
